<template>
    <div class="count-container classic">
        <div class="item bed-count" v-if="countInfo.bedrooms">
            <span class="iconfont icon-bed"></span>
            <span class="number">{{ countInfo.bedrooms.num }}</span>
            <span class="house">{{ countInfo.bedrooms.unit }}</span>
        </div>
        <div class="item bath-count" v-if="countInfo.bathrooms">
            <span class="iconfont icon-bath"></span>
            <span class="number">{{ countInfo.bathrooms.num }}</span>
            <span class="house">{{ countInfo.bathrooms.unit }}</span>
        </div>
        <div
            class="item sqft-count"
            v-if="countInfo.sqft"
        >
            <span class="iconfont icon-sqft"></span>
            <span class="number">{{
                countInfo.sqft.num
            }}</span>
            <span class="house">{{
                countInfo.sqft.unit
            }}</span>
        </div>
    </div>
</template>
<script>
import { mapState } from '@/store/helpers';
import { getCountObj } from '../../info-header-count.js';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['filling'],
    data: function() {
        return {};
    },
    computed: {
        ...mapState({
            'info': store => store.listingDetail.info || {}
        }),
        countInfo({ info }) {
            return getCountObj.call(this, info);
        }
    }
};
</script>
<style lang="scss">
.count-container.classic {
    display: flex;
    .item {
        margin-right: 20px;
        .number {
            font-size: 18px;
            color: var(--color-text);
            font-family: var(--font-bold);
            text-align: center;
            margin: 0 5px;
        }
        .house {
            font-size: 14px;
            color: var(--color-disable);
            text-align: center;
        }
        .iconfont {
            font-size: 20px;
        }
    }
}
@media (max-width: 600px) {
    .count-container.classic {
        .item {
            .number {
                font-size: 16px;
            }
            .house {
                font-size: 12px;
            }
            .iconfont {
                font-size: 16px;
            }
        }
    }
}
</style>
